import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=1f0c1672&scoped=true&"
import script from "./BooleanField.vue?vue&type=script&lang=js&"
export * from "./BooleanField.vue?vue&type=script&lang=js&"
import style0 from "./BooleanField.vue?vue&type=style&index=0&id=1f0c1672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c1672",
  null
  
)

export default component.exports